import * as screens from '@core/layouts/components/menu/screens';
import businessPartnersPaths from 'views/screens/BusinessPartners/paths';
import Icon from '../../utility/icomoon';

export default [
  {
    id: 'businessPartner',
    title: 'partners.businessPartner',
    icon: <Icon size={20} icon="Customers" />,
    iconName: 'Customers',
    permissions: [],
    navLink: businessPartnersPaths.editPartner,
    screenId: screens.BUSINESS_PARTNERS
  },
  {
    id: 'webServiceRates',
    title: 'partners.webServiceRates',
    icon: <Icon size={20} icon="WebService" />,
    iconName: 'WebService',
    permissions: [],
    navLink: businessPartnersPaths.webServiceRates,
    screenId: screens.WEB_SERVICE_RATES
  }
];
